import IcBagSuitcaseLargeCurve16 from "@traveloka/icon-kit-web/react/IcBagSuitcaseLargeCurve16";
import { useMemo } from "react";
import {
  BMDropdownField,
  BMDropdownFieldProps,
  BMDropdownOptionsValue,
} from "../../../../components";
import { useMobileContentResource } from "../../../../core/resource/MobileResourceProvider";
import { convert, formatCurrency } from "../../../../utils";
import { BaggageAddOns } from "../../FlightPrebook";

export type BMNationalityFieldProps = Omit<
  BMDropdownFieldProps<BaggageAddOns>,
  "option" | "variant" | "searchable" | "optionsSection"
> & {
  options: BaggageAddOns[];
};

export default function FlightBaggageField(props: BMNationalityFieldProps) {
  const { options, value, ...rest } = props;
  const { CorporateFlightGeneral: cr } = useMobileContentResource();

  const items: BMDropdownOptionsValue<BaggageAddOns>[] = useMemo(() => {
    return options.map((option) => ({
      label: `${option.baggageWeight}kg - ${formatCurrency(
        convert(option.priceWithCurrency)
      )}`,
      value: option,
    }));
  }, [options]);

  return (
    <BMDropdownField<BaggageAddOns>
      {...rest}
      variant="RADIO"
      value={value ?? (items.length ? items[0].value : null)}
      option={{
        items: items,
      }}
      optionsSection={{
        title: cr.baggageOptionsTitle,
      }}
      LeadingIcon={IcBagSuitcaseLargeCurve16}
    />
  );
}
